/**
 * When Express says findings are refreshing (a stale cache was served, or an
 * action just saved), read again a little later so the fix shows without a
 * reload. Capped so a slow or failed refresh never loops.
 */
export const OLLIE_REFRESH_FOLLOW_UP = Object.freeze({
  delayMs: 3000,
  maxFollowUps: 3,
})

/**
 * @param {{ refreshing?: boolean, followUp?: number }} params
 * @returns {boolean}
 */
export const shouldFollowUpOllieRefresh = ({ refreshing, followUp = 0 }) =>
  Boolean(refreshing) && followUp < OLLIE_REFRESH_FOLLOW_UP.maxFollowUps
